import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const PlayerContainer = styled.div<React.CSSProperties>`
  background: ${Colors.background};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

export default PlayerContainer;
